import { ITheme, mergeStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import {
  AppColors,
  getContextualMenuClassNames,
  IContextualMenuClassNames,
} from "@1js/acui-common";

export const getOverflowMenuClassNames = memoizeFunction(
  (appColors?: AppColors): ((theme: ITheme) => IContextualMenuClassNames) => {
    return (theme: ITheme): IContextualMenuClassNames => {
      return mergeStyleSets(getContextualMenuClassNames(theme, appColors), {
        root: {
          minWidth: 82,
        },
      }) as IContextualMenuClassNames;
    };
  }
);
